var exports = {
  "kL": "xa15a2ab7--142571--container",
  "DD": "xa15a2ab7--142571--title",
  "VA": "xa15a2ab7--142571--subtitle",
  "nV": "xa15a2ab7--142571--gallery",
  "ah": "xa15a2ab7--142571--preview-button",
  "M1": "xa15a2ab7--142571--details-button",
  "Vg": "xa15a2ab7--142571--grid",
  "AS": "xa15a2ab7--142571--item",
};

module.exports = exports;
